import React, { useEffect } from "react";
import { Layout, Typography, Divider } from "antd";
import PublicHeader from "../components/PublicHeader";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function Impressum() {
  useEffect(() => {
    document.title = "Impressum – Patrick Sauter – Smart Routing";
  }, []);

  return (
    <Layout style={{ minHeight: "100vh", background: "#ffffff" }}>
      <PublicHeader />

      <Content style={{ maxWidth: 900, margin: "40px auto", padding: "0 16px" }}>
        <Title level={2}>Impressum</Title>
        <Paragraph>Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)</Paragraph>

        <Paragraph>
          <b>Patrick Sauter</b><br />
          Sportplatzweg 11<br />
          72181 Starzach
        </Paragraph>

        <Paragraph>
          <b>Kontakt:</b><br />
          Telefon: 0157 5579 0124<br />
          E-Mail: info@patricksauter.de
        </Paragraph>

        <Paragraph>
          <b>Umsatzsteuer-ID:</b><br />
          Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
          DE 359 002 944
        </Paragraph>

        <Paragraph>
          <b>Verantwortlich für journalistisch-redaktionelle Inhalte nach § 18 Abs. 2 MStV:</b><br />
          Patrick Sauter<br />
          Sportplatzweg 11<br />
          72181 Starzach
        </Paragraph>

        <Divider />

        <Title level={3}>Haftungsausschluss</Title>
        <Paragraph>
          Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links.
          Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
        </Paragraph>

        <Title level={3}>Urheberrecht</Title>
        <Paragraph>
          Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
          Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts
          bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
        </Paragraph>
      </Content>
    </Layout>
  );
}
